var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriceManag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#858585",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77185 14.584L8.53985 12.408H8.01185V14.584H6.89185V8.99998H8.98785C9.41985 8.99998 9.78785 9.07732 10.0918 9.23198C10.3958 9.38132 10.6225 9.58665 10.7718 9.84798C10.9265 10.104 11.0038 10.392 11.0038 10.712C11.0038 11.08 10.8972 11.4133 10.6838 11.712C10.4705 12.0053 10.1532 12.208 9.73185 12.32L11.0678 14.584H9.77185ZM8.01185 11.568H8.94785C9.25185 11.568 9.47851 11.496 9.62785 11.352C9.77718 11.2027 9.85185 10.9973 9.85185 10.736C9.85185 10.48 9.77718 10.2827 9.62785 10.144C9.47851 9.99998 9.25185 9.92798 8.94785 9.92798H8.01185V11.568Z",
    fill: "#858585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1048 8.99998V14.584H16.9848V10.952L15.4888 14.584H14.6408L13.1368 10.952V14.584H12.0168V8.99998H13.2888L15.0648 13.152L16.8408 8.99998H18.1048Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceManag);
export default __webpack_public_path__ + "static/media/price_manag.2b4a20c8aad68174c6a804d775982fe4.svg";
export { ForwardRef as ReactComponent };